import * as types from "./mutation_types";


export default {

  [types.SET_FORM_SCREENS_VISIBILITY](state, data) {
    Object.assign(state, {
      screensVisibility: data
    });
  },
  [types.SET_FORM_FIELDS_VISIBILITY](state, data) {
    Object.assign(state, {
      fieldsVisibility: data
    });
  },
  [types.SET_FORM_FIELDS_VALUES](state, data) {
    Object.assign(state, {
      fieldValues: data
    });
  },

  [types.UPDATE_FORM_FIELD_VALUE](state, data) {
    Object.assign(state, {
      fieldValues: Object.assign({}, state.fieldValues, data)
    });
  },

  [types.NEXT_SCREEN](state) {
    Object.assign(state, {
      activeScreen: state.activeScreen + 1
    });
  },

  [types.SCREENS_VISIBILITY_VERSION_UP](state) {
    Object.assign(state, {
      screensVisibilityVersion: state.screensVisibilityVersion + 1
    });
    //console.log('SCREENS_VISIBILITY_VERSION_UP ' + state.screensVisibilityVersion);
  },
  [types.FIELDS_VISIBILITY_VERSION_UP](state) {
    Object.assign(state, {
      fieldsVisibilityVersion: state.fieldsVisibilityVersion + 1
    });
    //console.log('FIELDS_VISIBILITY_VERSION_UP ' + state.fieldsVisibilityVersion);
  },

  [types.BACK](state) {
    Object.assign(state, {
      activeScreen: state.activeScreen - 1
    });
  },
  [types.SET_SCREEN](state, data) {
    Object.assign(state, {
      activeScreen: data
    });
  },

  [types.ENABLE_DEBUG](state) {
    Object.assign(state, {
      debug: true
    });
  },

  [types.SET_REVIEW_VISIBLE](state) {
    Object.assign(state, {
      review_visible: true
    });
  },

  [types.SET_REVIEW_SCREEN_INDEX](state, index) {
    Object.assign(state, {
      review_index: index
    });
  },

  [types.SET_LOAN_TYPE](state, data) {
    Object.assign(state, {
      loan_type: data
    });
  },

  [types.SET_PASSED_PARAMS](state, data) {
    Object.assign(state, {
      passed_params: data
    });
  },

  [types.SET_LOGO](state, data) {
    Object.assign(state, {
      logo: data
    });
  },
};
